/**
 * Checks if the given text is valid JSON.
 *
 * @param {string} text - The text to check.
 * @returns {boolean} - Returns true if the text is valid JSON, false otherwise.
 */
export default function isValidJSON(text) {
  if (typeof text !== 'string') return false;
  try {
    JSON.parse(text);
    return true;
  } catch {
    return false;
  }
}